export default {
  data() {
    return {
      isTwoDigitsSelected: false,
      isFourDigitsSelected: false,
      isTextSelected: false,
      defaultValue: ''
    }
  },
  methods: {
    selectTwoDigits() {
      this.isTwoDigitsSelected = true
    },
    selectFourDigits() {
      this.isFourDigitsSelected = true
    },
    selectText() {
      this.isTextSelected = this.defaultValue !== ''
    }
  }
}
